import { render, staticRenderFns } from "./ExtraordinaryItem.vue?vue&type=template&id=ca73a0d0&scoped=true"
import script from "./ExtraordinaryItem.vue?vue&type=script&lang=js"
export * from "./ExtraordinaryItem.vue?vue&type=script&lang=js"
import style0 from "./ExtraordinaryItem.vue?vue&type=style&index=0&id=ca73a0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca73a0d0",
  null
  
)

export default component.exports